var render = function () {
  var _this = this;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.tagSelectorContainer
  }, [_vm._t("default"), _vm.removable ? _c('span', [_c('i', {
    on: {
      "click": function click() {
        _this.$emit('remove');
      }
    }
  })]) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }